module.exports = __webpack_public_path__ + "img/shanshiguang.e24469c1.png";